import documentsService from "@/services/DocumentsService";
import { get, last } from "lodash";
import Vue from "vue";

const folder = {
  state: {
    documentToEdit: {
      document_versions: [],
      document_state: ""
    }
  },
  getters: {
    documentToEdit(state) {
      return state.documentToEdit;
    }
  },
  mutations: {
    setDocumentToEdit(state, payload) {
      state.documentToEdit = payload;
    },
    changeFieldValue(state, { fieldName, val }) {
      const filledFields = get(
        last(state.documentToEdit.document_versions),
        "filled_fields",
        {}
      );
      Vue.set(filledFields, fieldName, val);
    },
    changeDocumentState(state, status) {
      state.documentToEdit.document_state = status;
    }
  },
  actions: {
    setDocumentToEdit({ commit }, data) {
      commit("setDocumentToEdit", data);
    },
    getDocument({ commit }, payload) {
      commit("toggleLoader", { show: true });
      documentsService
        .getDocument(payload)
        .then(({ data }) => {
          commit("setDocumentToEdit", data);
        })
        .finally(() => {
          commit("toggleLoader", { show: false });
        });
    },
    async saveAsDocument(
      { commit },
      { id, raw, filledFields, documentState, geolocation }
    ) {
      await documentsService.updateDocument({
        id,
        raw,
        filledFields,
        documentState,
        geolocation
      });
      commit("changeDocumentState", documentState);
    },
    async keepAsDraft({ commit }, { id, raw, filledFields, documentState }) {
      await documentsService.updateDocument({
        id,
        raw,
        filledFields,
        documentState
      });
    },
    changeDocumentFieldValue({ commit }, { fieldName, val }) {
      commit("changeFieldValue", { fieldName, val });
    }
  }
};

export default folder;



// WEBPACK FOOTER //
// ./src/vuex/folder/documents.js